import { Text as RNText, View } from 'react-native';

import { cn } from './cn';

export type BadgeTone = 'pro' | 'signal' | 'neutral' | 'outline';

const TONE: Record<BadgeTone, string> = {
  pro: 'bg-ink',
  signal: 'bg-signal',
  neutral: 'bg-well',
  outline: 'border border-border-strong',
};

const TONE_TEXT: Record<BadgeTone, string> = {
  pro: 'text-on-ink',
  signal: 'text-on-signal',
  neutral: 'text-muted',
  outline: 'text-muted',
};

export interface BadgeProps {
  label: string;
  tone?: BadgeTone;
  className?: string;
}

/** Small uppercase mono pill — PRO, FREE, counts. */
export function Badge({ label, tone = 'neutral', className }: BadgeProps) {
  return (
    <View className={cn('self-start rounded-md px-2 py-0.5', TONE[tone], className)}>
      <RNText
        className={cn(
          'font-accent text-[10px] uppercase tracking-[0.1em]',
          TONE_TEXT[tone],
        )}
      >
        {label}
      </RNText>
    </View>
  );
}
